module.exports = __webpack_public_path__ + "static/img/__8285.d4eac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8285.jpg
// module id = mRQW
// module chunks = 0